import { authorizerApi } from '@/services/authorizerApi'
import { GetAuthorizationDataMapper } from '../mapper/GetAuthorizationData/GetAuthorizationData.mapper'
import {
  GetAuthorizationData,
  GetAuthorizationDataRaw,
} from '../mapper/GetAuthorizationData/GetAuthorizationData.types'

export class AuthorizerServices {
  static async getAuthorizationData(
    authorizerId?: number,
  ): Promise<GetAuthorizationData> {
    const { data } = await authorizerApi.get<GetAuthorizationDataRaw>(
      `/autorizador/un/v1/atendimento/obter-guia?idAutorizador=${authorizerId}&sistema=CONEXA`,
    )

    return GetAuthorizationDataMapper.toDomain(data)
  }
}
